import { useParams } from "react-router-dom";
import { useGetInviteFriends } from "../../services/ContentManager";
import NTMXGrid, { timestampFormatterWithTimezone } from "../../components/NTMXGrid";
import React from "react";
import RenderUserRedirect from "../../components/cellRender/RenderUserRedirect";
import { useTranslation } from "react-i18next";


const inviteFriendsStatus = Object.freeze([
    {
        id: 0,
        name: 'inviteFriendsStatus0'
    }, {
        id: 1,
        name: 'inviteFriendsStatus1'
    }, {
        id: 2,
        name: 'inviteFriendsStatus2'
    }, {
        id: 3,
        name: 'inviteFriendsStatus3'
    }, {
        id: 4,
        name: 'inviteFriendsStatus4'
    }, {
        id: 5,
        name: 'inviteFriendsStatus5'
    }
]);

// Perche' a chi invita non e' stato riconosciuto il premio dell'iniziativa (il premio community
// viene assegnato comunque). Ordinali di InviteAwardSkipReason lato backend: vuoto = premio dato.
const inviterAwardSkipReasons = Object.freeze([
    {
        id: 0,
        name: 'notEnrolledToOrganization',
        fallback: "Non iscritto all'iniziativa"
    }, {
        id: 1,
        name: 'initiativeWithoutInviteAward',
        fallback: 'Iniziativa senza premio invito'
    }
]);

export default function InviteFriends() {

    const { t } = useTranslation();
    let { id } = useParams();
    let { inviteFriends, status } = useGetInviteFriends(id);

    const defaultColumns = [
        {
            headerName: t('code'),
            field: 'invitationCode',
            width: 160,
        }, {
            headerName: t('userID'),
            field: 'uid',
            width: 280
        }, {
            headerName: t('username'),
            field: 'username',
            width: 200,
            renderCell: (params) => <RenderUserRedirect value={params.value} url={params.row.uid} />
        }, {
            headerName: t('email'),
            field: 'email',
            width: 220,
        }, {
            headerName: t('invitedUserUid'),
            field: 'invitedUserUid',
            width: 280
        }, {
            headerName: t('invitedUserEmail'),
            field: 'invitedUserEmail',
            width: 220,
        }, {
            field: 'timestamp',
            headerName: t('winDate'),
            width: 280,
            ...timestampFormatterWithTimezone,
        }, {
            headerName: t('status'),
            field: 'status',
            width: 160,
            valueGetter: (params) => params.value !== undefined && t(inviteFriendsStatus.find(s => s.id === params.value)?.name),
        }, {
            headerName: t('notes'),
            field: 'inviterAwardSkipReason',
            width: 240,
            valueGetter: (params) => {
                const reason = inviterAwardSkipReasons.find(r => r.id === params.value);
                return reason ? t(reason.name, reason.fallback) : "";
            },
        },
    ];

    return <div>
        <NTMXGrid
            key={"manager-invite-friends-tables"}
            columns={defaultColumns}
            rows={inviteFriends || []}
            getRowId={(row) => inviteFriends && row.id}
            title={t('inviteFriends')}
            loading={status === "loading"}
        />
    </div>
}
